import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb' 
const SchoolHours = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="School Hours" midBreadcrumb="Rules" mainBreadcrumb="School Hours" ></Breadcrumb>
            <div  className='inner-page'>
                <div  className='container'>
                    <div  className="row uniform">
                        <div  className="col-12">
                            <h2 className="mainhead">School Hours</h2>
                            <h3 className="subhead">Realize that now, in this moment of time, you are creating. You are creating your next moment</h3>
                        </div>
                        <div  className="col-md-6">

                            <div  className="tablescroll table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" colspan="2">Summer</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>April to May</td>
                                            <td>7:30 a.m. to 1:30 p.m.</td>
                                        </tr>
                                        <tr>
                                            <td>July to October</td>
                                            <td>8:00 a.m. to 2:00 p.m.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div  className="col-md-6">
                            <div  className="tablescroll table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" colspan="2">Winter</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>November to December</td>
                                            <td>8:30 a.m. to 2:30 p.m.</td>
                                        </tr>
                                        <tr>
                                            <td>January to February</td>
                                            <td>9:00 a.m to 2:30 p.m</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div  className="col-12">
                            <h3 className="subhead">Office Hours</h3>
                        </div>
                        <div  className="col-md-6">
                            <div  className="tablescroll table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" colspan="2">Principal’s Office Hours</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Summer</td>
                                            <td>8:30 a.m. to 10:00 a.m.</td>
                                        </tr>
                                        <tr>
                                            <td>Winter</td>
                                            <td>9:00 a.m. to 10:30 a.m.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div  className="col-md-6">
                            <div  className="tablescroll table-responsive">
                                <table className="table table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" colspan="2">School Office Hours</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Summer</td>
                                            <td>8:00 a.m. to 3:00 p.m.</td>
                                        </tr>
                                        <tr>
                                            <td>Winter</td>
                                            <td>9:00 a.m. to 3:30 p.m.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div  className="col-md-12">
                            <p><b>Note: </b>Parents are permitted to meet the teachers on second Saturday of the month between 11:00 a.m.
                                & 12:30 p.m. No school business will be transacted on holidays.</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default SchoolHours